// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'center', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">
        Разработка компании{' '}
        <Link href="https://proggear.ru/" target="_blank" underline="hover">
          ProGGear
        </Link>
      </Typography>
      <Typography variant="caption">•</Typography>
      <Typography variant="caption">
        Хостинг предоставлен компанией{' '}
        <Link href="https://galaxydata.ru/" target="_blank" underline="hover">
          GalaxyData
        </Link>
      </Typography>
    </Stack>
  );
}
